<template>
	<div class="report_container full">
		<el-container class="full">
			<el-aside width="200px" style="background: rgb(244, 244, 245);">
				<div style="padding: 10px;">
					<datetree :beginyear="2026" ref="datetree" :key="datetreeKey" :defaulttime="defaulttime"
						@select="datetreeChange" />
				</div>
			</el-aside>
			<el-container style="position: relative;box-sizing: border-box;padding: 10px;">
<!-- 				<el-header height="45px" class="head">
					<el-switch v-model="statics" @change="staticsChange" active-text="显示统计" inactive-text="" :active-value="1" :inactive-value="0"></el-switch>
				</el-header> -->
				<vxe-grid ref="goodskpiIndex" style="width: 100%;" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</el-container>
		</el-container>
		
		<edit-form :data="sourcedata" ref="editForm" @success="editSubmit" />
		
	</div>
</template>
<style scoped>
	.head {
		padding: 5px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import datetree from './datetree/tree.vue'
	import editForm from './edit/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				statics:0,
				datetreeKey: Math.random(),
				defaulttime: this.$Moment().startOf('month').valueOf(),
				modal_title: 'title',
				modal_width: 600,
				modal_height: 500,
				sourcedata:{},
				list_formConfig: [{
					field: 'a',
					title: 'A',
					itemRender: {
						name: '$input'
					}
				}],
				list_columns: [{
						title: '#',
						width: 50,
						fixed: 'left',
						type: 'checkbox'
					},{
						field: 'belongstaffid',
						title: '负责人',
						fixed: 'left',
						width: 100,
						sortable: true,
						showOverflow: true,
						slots: {
							default: ({
								row
							}) => {
								return window.systemMethods.getstaff(row.belongstaffid)
							}
						}
					},{
						field: 'shopname',
						title: '店铺',
						width: 100,
						fixed: 'left',
						sortable: true,
						showOverflow: true,
					},
					{
						field: 'code',
						title: '线上商品ID',
						fixed: 'left',
						width: 120,
					},
					{
						field: 'title',
						title: '名称',
						width: 100,
						sortable: true,
						showOverflow: true,
					},
					{
						field: 'basedaysalesum',
						title: '保底日销',
						width: 100,
						sortable: true
					},
					{
						field: 'realdaysalesum',
						title: '实际日销',
						width: 100,
						sortable: true
					},
					{
						field: 'basemonthsalesum',
						title: '保底月销',
						width: 100,
						sortable: true
					},
					{
						field: 'realmonthsalesum',
						title: '实际月销',
						width: 100,
						sortable: true
					},
					{
						field: 'targetmonthsalesum',
						title: '预计月销',
						width: 100,
						sortable: true
					},
					{
						field: 'targetdaypayTotalByrCnt',
						title: '预计日买家',
						width: 100,
						sortable: true
					},
					{
						field: 'targetmonthpayTotalByrCnt',
						title: '预计月买家',
						width: 100,
						sortable: true
					},
					{
						field: 'payTotalByrCnt',
						title: '实际月买家',
						width: 100,
						sortable: true
					},
					{
						field: 'targetdaycharge',
						title: '预计日花费',
						width: 100,
						sortable: true
					},
					{
						field: 'targetmonthcharge',
						title: '预计月花费',
						width: 100,
						sortable: true
					},
					{
						field: 'expenses',
						title: '实际月花费',
						width: 100,
						sortable: true,
					},
					{
						field: 'wlnbi_profit',
						title: '利润',
						width: 100,
						sortable: true,
						showOverflow: true,
					},
					{
						field: 'expensesPercent',
						title: '花费占比',
						fixed: 'right',
						width: 100,
						sortable: true,
						slots: {
							default: ({
								row
							}) => {
								return row.expensesPercent + '%'
							}
						}
					},
					{
						field: 'wlnbi_profitRate',
						title: '利润率',
						fixed: 'right',
						width: 100,
						sortable: true,
						showOverflow: true,
						slots: {
							default: ({
								row
							}) => {
								return ((row.wlnbi_profitRate ? row.wlnbi_profitRate : 0) * 100).toFixed(2) + '%'
							}
						}
					},
					{
						title: '任务进度',						
						fixed: 'right',
						align:'center',
						children: [
							{
								field: 'salesumProgress',
								title: '月销',
								width: 100,
								slots: {
									default: ({
										row
									}) => {
										return row.salesumProgress + '%'
									}
								}
							},
							{
								field: 'payTotalByrCntProgress',
								title: '月买家',
								width: 100,
								slots: {
									default: ({
										row
									}) => {
										return row.payTotalByrCntProgress + '%'
									}
								}
							},
							{
								field: 'expensesProgress',
								title: '月花费',
								width: 100,
								slots: {
									default: ({
										row
									}) => {
										return row.expensesProgress + '%'
									}
								}
							}
						]
					},
					{
						field: 'biztime',
						title: '目标月份',
						width: 100,
						sortable: true,
						showOverflow: true,
						slots: {
							default: ({
								row
							}) => {
								return window.systemMethods.timestampToDate(row.biztime,'month')
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.sourcedata = {
				biztime:this.defaulttime
			}
		},
		methods: {
			datetreeChange(e) {
				this.defaulttime = e.id
				this.sourcedata = {
					biztime:e.id
				}
				this.customreload()

			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = 'shopgoodskpi_list'
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50,2000],
				}
				gridOptions.formConfig = false
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				},{
					name: '导入',
					status: 'danger',
					code: 'import'
				},{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '批量删除',
					status: 'info',
					code: 'batchdelete'
				},{
					name: '查看模式',
					status: '',
					dropdowns:[{
						name:"明细",
						code: 'detailmode'
					},{
						name:"统计",
						code: 'staticsmode'
					}]
				}]
			},
			list_importMethod(e) {
				if(typeof this.defaulttime === 'number' && isFinite(this.defaulttime)){
					let table = e.$table
					this.loading = true
					let file = e.file
					let reader = new FileReader();
					reader.onload = (e) => {
						let data = e.target.result
						let workbook = this.$XLSX.read(data, {
							type: 'binary',
						})
						let sheetName = workbook.SheetNames[0];
						let worksheet = workbook.Sheets[sheetName]
						let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
							raw: false
						})
						let tablecolumns = this.$Lodash.groupBy(table.getColumns(), 'title')
						let insertData = []
						jsonData.forEach((item) => {
							let obj = {
								biztime:this.defaulttime/1000
							}
							for (let i in item) {
								if (tablecolumns[i]) {
									let columns = tablecolumns[i][0]
									if (columns.editRender) {
										this.list_importEditRanderParse(columns, item[i], obj)
									} else {
										obj[columns.field] = item[i]
									}
								}
							}
							for (let i in tablecolumns) {
								if (tablecolumns[i][0].field) {
									if (obj[tablecolumns[i][0].field] === null || obj[tablecolumns[i][0]
											.field] === undefined) {
										obj[tablecolumns[i][0].field] = null
									}
								}
							}
								//console.log(obj)
							insertData.push(obj)
						})
					
						this.$api.BIshopgoodskpi.batchsave({data:insertData}).then(()=>{
							this.customreload()
							this.loading = false
						},()=>{						
							this.loading = false
						})
						console.log(insertData)
						
					}
					reader.readAsBinaryString(file)
				}else{
					this.$message.error('请选择月份')
				}
			},
			customreload(){
				this.$refs.goodskpiIndex.commitProxy('query')
			},
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.BIshopgoodskpi.list({
						...{
							biztime:this.sourcedata.biztime,
							statics:this.statics,
						},
						...page,
						...updateForm,
						...other,
					}).then((res)=>{
						resolve(res)
					},()=>{
						resolve({list:[]})
						this.loading = false
					})
				})
			},	
			staticsChange(){
				this.$refs.goodskpiIndex.reloadData([])
				let columns = this.$refs.goodskpiIndex.getTableColumn()
				if(this.statics == 0){
					columns.fullColumn.forEach((item)=>{
						item.visible = true
					})
				}else{
					columns.fullColumn.forEach((item)=>{
						if(item.field == 'shopname' || item.field == 'code' || item.field == 'title' || !item.field){
							item.visible = false
						}						
					})
				}
				this.$refs.goodskpiIndex.refreshColumn()
				this.customreload()				
			},
			detailmode(){
				this.statics = 0
				this.staticsChange()
			},
			staticsmode(){
				this.statics = 1
				this.staticsChange()
			},
			add(){
				this.$refs.editForm.modal_show()
			},
			edit(row){
				this.sourcedata = JSON.parse(JSON.stringify(row))
				this.sourcedata.biztime *=1000
				this.$refs.editForm.modal_show()
			},
			del(row){
				this.$confirm('是否确认删除' , '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.BIshopgoodskpi.delete(row.id).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			batchdelete(){
				let data =  this.$refs.goodskpiIndex.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}	
				let ids = data.map((item)=>{
					return item.id
				})
				this.$confirm('是否确认删除' , '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.BIshopgoodskpi.batchdelete({ids:ids}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			editSubmit(){
				this.sourcedata = {
					biztime:this.defaulttime
				}
				this.customreload()
			},
			createcostorder(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				this.importpredata = row.map((item)=>{
					let company = window.systemData.company.find((_item)=>{
						return _item.name == item.accName
					})
					return {
						'main|bankAcc':item.bankAcc,
						'main|rcvAcc':item.oppAccNo,
						'main|serialId':item.serialId,
						'main|paymenttime':item.transTime,
						'main|biztime':item.transTime,
						'main|companyid':company?company.id:null,
						'costorder_detail|businessdepartmentid':null,
						'costorder_detail|costamount':item.cdSign == 0 ? -item.amt : item.amt
					}
				})
				this.importModuleName = 'costorder'
				this.$refs[this.importRef].importpanel()
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			datetree,
			editForm
		}
	}
</script>